import { WhatsAppIcon } from 'assets/icons/Social'
import React from 'react'

export default function FomoSection() {
  return (
    <div className="bg-[#1A1B1F] full-bleed py-12 flex flex-col items-center md:flex-row justify-between gap-4">
      <div className="w-full md:w-3/12 text-2xl font-semibold">
        <span className="text-green-500">FOMO</span> our weekly events?
      </div>

      <div className="w-full md:w-6/12 text-base">
        Do not miss any of our sessions and masterclasses. Join our Whatsapp
        Group to stay connected!
      </div>

      <div className="self-start -mx-2.5">
        <a
          href="https://devsnest.in/r/techschool-wa"
          target="_blank"
          rel="noreferrer">
          <div className="text-base sm:text-lg py-2 px-6 bg-green-800 hover:bg-green-900 rounded cursor-pointer mx-2.5">
            <div className="flex items-center">
              <WhatsAppIcon className="h-5 w-5" />
              <span className="ml-2">Join WhatsApp</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  )
}
